export default "__VITE_ASSET__e934f01c__"